<div class="font-serif">

  <!-- ═══ CIRCLE FILTER ROW (only when space or category is active) ═══ -->
  <div *ngIf="circleFilterType" class="border-b border-gray-200 bg-white">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6 pt-6 pb-4">
      <div class="flex gap-5 md:gap-6 overflow-x-auto py-1 px-1"
        style="scrollbar-width: none; -ms-overflow-style: none;">
        <!-- "Back" — goes to previous pagination page (49 → 48); falls back to history when on page 1 -->
        <div (click)="goBack()" class="flex flex-col items-center gap-2 shrink-0 cursor-pointer group">
          <div
            class="w-16 h-16 md:w-[72px] md:h-[72px] rounded-full overflow-hidden flex items-center justify-center bg-gradient-to-br from-[#f5f0eb] to-[#e8ddd3] group-hover:from-[#ecdcdc] group-hover:to-[#d9bdbd]">
            <svg xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 md:w-7 md:h-7 text-[#600b0b]/60 group-hover:text-[#600b0b]"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M19 12H5" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </div>
          <span class="text-[8px] md:text-[9px] font-bold uppercase tracking-[0.05em] text-center w-16 md:w-[76px] leading-tight text-gray-500 group-hover:text-[#600b0b]">
            Back
          </span>
        </div>
        <div *ngFor="let item of circleItems; trackBy: trackById" (click)="selectCircleItem(item)"
          class="flex flex-col items-center gap-2 shrink-0 cursor-pointer group">
          <div
            [class]="'w-16 h-16 md:w-[72px] md:h-[72px] rounded-full overflow-hidden ' + (circleSelectedIds.has(item.id) ? 'ring-2 ring-[#600b0b]' : 'ring-1 ring-transparent group-hover:ring-2 group-hover:ring-[#600b0b]/40')">
            <img *ngIf="getCircleImage(item)" [src]="getCircleImage(item)" [alt]="item.display_name || item.name"
              class="w-full h-full object-cover rounded-full" />
            <div *ngIf="!getCircleImage(item)"
              class="w-full h-full bg-gradient-to-br from-[#f5f0eb] to-[#e8ddd3] flex items-center justify-center rounded-full">
              <span class="text-lg font-bold text-[#600b0b]/40">{{ (item.display_name || item.name).charAt(0) }}</span>
            </div>
          </div>
          <span
            [class]="'text-[8px] md:text-[9px] font-bold uppercase tracking-[0.05em] text-center w-16 md:w-[76px] leading-tight line-clamp-2 ' + (circleSelectedIds.has(item.id) ? 'text-[#600b0b]' : 'text-gray-500 group-hover:text-[#600b0b]')">
            {{ item.display_name || item.name }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ CONTROL BAR (breadcrumb + sort + filters + chips) ═══ -->
  <div class="border-b border-gray-200 bg-white sticky top-[48px] md:top-[68px] z-30">
    <!-- Desktop bar -->
    <div class="max-w-[1440px] mx-auto px-3 md:px-6 flex items-center h-11 md:h-12 gap-2 md:gap-4">

      <!-- Filter button (LEFT) -->
      <button (click)="showFiltersMobile = true"
        class="flex items-center gap-1.5 border border-gray-200 rounded-lg px-2 md:px-3 py-1.5 text-[10px] md:text-xs font-bold uppercase tracking-wider text-gray-700 hover:border-gray-400 transition-all bg-white shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
        <span>Filters</span>
        <span *ngIf="activeFilterCount > 0"
          class="bg-[#600b0b] text-white rounded-full min-w-[18px] h-[18px] text-[9px] flex items-center justify-center font-bold px-1">{{
          activeFilterCount }}</span>
      </button>

      <!-- Sort dropdown moved to right side -->

      <!-- Active filter chips (inline in control bar) -->
      <div *ngIf="activeFilterChips.length > 0" class="flex items-center gap-1.5 overflow-x-auto min-w-0"
        style="scrollbar-width: none; -ms-overflow-style: none;">
        <button *ngFor="let chip of activeFilterChips" (click)="removeChip(chip)"
          class="inline-flex items-center gap-1 bg-[#fdf5f5] border border-[#600b0b]/20 text-[#600b0b] px-2 py-0.5 rounded-full text-[10px] font-semibold capitalize hover:bg-[#600b0b] hover:text-white transition-all group shrink-0 whitespace-nowrap">
          <span *ngIf="chip.type === 'color' && chip.id"
            class="w-2.5 h-2.5 rounded-full border border-gray-200 shrink-0"
            [style.background-color]="getColorHex(chip.id)"></span>
          {{ chip.label }}
          <svg xmlns="http://www.w3.org/2000/svg" class="w-2.5 h-2.5 opacity-60 group-hover:opacity-100"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <button (click)="clearAllFilters()"
          class="text-[10px] text-gray-500 hover:text-[#600b0b] font-bold uppercase tracking-wider shrink-0 whitespace-nowrap hover:underline">
          Clear All
        </button>
      </div>

      <!-- Breadcrumb (only when no chips) -->
      <div *ngIf="activeFilterChips.length === 0"
        class="flex items-center gap-1.5 md:gap-2 text-[10px] md:text-xs text-gray-400 min-w-0">

        <span *ngIf="activeSpaceName || activeCategoryName || pageTitle !== 'All Wallpapers'"
          class="shrink-0">&gt;</span>
        <span *ngIf="activeSpaceName"
          class="font-bold uppercase tracking-wider text-[#600b0b] truncate max-w-[80px] md:max-w-none">{{
          activeSpaceName }}</span>
        <span *ngIf="!activeSpaceName && activeCategoryName"
          class="font-bold uppercase tracking-wider text-[#600b0b] truncate max-w-[80px] md:max-w-none">{{
          activeCategoryName }}</span>
        <span *ngIf="!activeSpaceName && !activeCategoryName && pageTitle !== 'All Wallpapers'"
          class="font-bold uppercase tracking-wider text-[#600b0b] truncate max-w-[80px] md:max-w-none">{{ pageTitle
          }}</span>
      </div>

      <!-- Spacer -->
      <div class="flex-1"></div>

      <!-- Design count -->
      <span class="text-[10px] md:text-xs text-gray-400 shrink-0 hidden sm:inline">{{ totalRecords }} Designs</span>

      <!-- Sort dropdown (RIGHT) -->
      <div class="relative shrink-0">
        <button (click)="showSortDropdown = !showSortDropdown"
          class="flex items-center gap-1.5 border border-gray-200 rounded-lg px-2 md:px-3 py-1.5 text-[10px] md:text-xs font-bold uppercase tracking-wider text-gray-700 hover:border-gray-400 transition-all bg-white">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" class="md:hidden">
            <path d="M3 6h18M6 12h12M9 18h6" />
          </svg>
          <span class="hidden md:inline">{{ sortBy }}</span>
          <span class="md:hidden">Sort</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div *ngIf="showSortDropdown"
          class="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl z-40 min-w-[160px] md:min-w-[180px] py-1">
          <button *ngFor="let opt of sortOptions" (click)="onSortChange(opt); showSortDropdown = false"
            [class]="'w-full text-left px-4 py-2 text-xs font-semibold transition-all ' + (sortBy === opt ? 'bg-[#600b0b] text-white' : 'text-gray-700 hover:bg-gray-50')">
            {{ opt }}
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Close sort dropdown on outside click -->
  <div *ngIf="showSortDropdown" class="fixed inset-0 z-20" (click)="showSortDropdown = false"></div>

  <!-- ═══ PRODUCT GRID ═══ -->
  <div class="max-w-[1440px] mx-auto px-3 md:px-6 py-4 md:py-5">

    <!-- Similar wallpapers banner -->
    <div *ngIf="similarSourceName"
      class="flex items-center justify-between bg-[#fdf5f5] border border-[#600b0b]/20 rounded-lg px-3 md:px-4 py-2.5 mb-4">
      <p class="text-xs md:text-sm text-gray-700">
        Showing wallpapers similar to <span class="font-bold text-[#600b0b]">"{{ similarSourceName }}"</span>
      </p>
      <button (click)="clearSimilar()"
        class="text-[10px] md:text-xs font-bold text-[#600b0b] uppercase tracking-wider hover:underline shrink-0 ml-3">
        Clear
      </button>
    </div>

    <!-- Mobile design count -->
    <div class="flex items-center justify-between mb-3 sm:hidden">
      <p class="text-xs text-gray-500 font-medium">{{ totalRecords }} Designs found</p>
    </div>

    <!-- Loading skeleton -->
    <!-- Shared placeholder grid (app-card-skeleton). This block was copied
         verbatim into three listing templates; the component IS that block, so
         the pulse and the card shape can no longer drift between pages. -->
    <div *ngIf="isLoading" class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
      <app-card-skeleton [count]="pageSize" aspect="4 / 3"></app-card-skeleton>
    </div>

    <!-- Error state -->
    <div *ngIf="loadError && !isLoading" class="text-center py-16 md:py-20">
      <div
        class="w-20 h-20 md:w-24 md:h-24 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4 md:mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="text-red-300">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h3 class="text-lg md:text-xl font-serif text-gray-600 mb-2">Failed to load wallpapers</h3>
      <button (click)="loadWallpapers()" class="text-[#600b0b] text-sm font-bold underline">Try again</button>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoading && !loadError && filteredWallpapers.length === 0" class="text-center py-16 md:py-20">
      <div
        class="w-20 h-20 md:w-24 md:h-24 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4 md:mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-300">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
      <h3 class="text-lg md:text-xl font-serif text-gray-600 mb-2">No wallpapers found</h3>
      <button *ngIf="hasActiveFilters" (click)="clearAllFilters()"
        class="text-[#600b0b] text-sm font-bold underline">Clear all filters</button>
    </div>

    <!-- Grid -->
    <div *ngIf="!isLoading && filteredWallpapers.length > 0" class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
      <div *ngFor="let wp of paginatedWallpapers; trackBy: trackByWp" (click)="navigateToPDP(wp)" class="group cursor-pointer">
        <div
          class="relative aspect-[4/3] rounded-lg md:rounded-xl overflow-hidden shadow-sm group-hover:shadow-xl transition-all duration-500 bg-gray-100">
          <!-- Image -->
          <img [src]="wp.list_thumbnail" [alt]="wp.name" loading="lazy"
            class="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out group-hover:scale-105 opacity-0"
            (load)="$event.target['classList'].remove('opacity-0')" />

          <!-- Collection-type diagonal ribbon (top-left) — subtle.
               Burgundy for Exclusive, brand gold for Premium. Gold carries dark
               text because white is unreadable at this size on a mid-tone. -->
          <div *ngIf="isExclusive(wp)"
            class="absolute top-0 left-0 w-[65px] md:w-[80px] h-[65px] md:h-[80px] overflow-hidden pointer-events-none z-10">
            <div
              class="absolute top-[14px] md:top-[18px] -left-[30px] md:-left-[34px] w-[105px] md:w-[120px] bg-[#600b0b] text-white text-[6px] md:text-[7px] font-medium uppercase tracking-[0.2em] text-center py-[2px]"
              style="transform: rotate(-45deg);">
              Exclusive
            </div>
          </div>
          <div *ngIf="isPremium(wp)"
            class="absolute top-0 left-0 w-[65px] md:w-[80px] h-[65px] md:h-[80px] overflow-hidden pointer-events-none z-10">
            <div
              class="absolute top-[14px] md:top-[18px] -left-[30px] md:-left-[34px] w-[105px] md:w-[120px] bg-[#c49a6c] text-[#4a2f18] text-[6px] md:text-[7px] font-semibold uppercase tracking-[0.2em] text-center py-[2px]"
              style="transform: rotate(-45deg);">
              Premium
            </div>
          </div>

          <!-- Top gradient overlay (mirrors bottom strip) — hover only -->
          <div
            class="absolute top-0 left-0 right-0 h-16 md:h-20 bg-gradient-to-b from-black/70 via-black/40 to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-[5]">
          </div>

          <!-- Top-right action buttons (wishlist + view similar) — show on hover only -->
          <div
            class="absolute top-2 right-2 flex flex-col gap-1.5 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <!-- Wishlist -->
            <button (click)="$event.stopPropagation(); $event.preventDefault(); toggleWishlistItem(wp, $event)"
              class="w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all hover:scale-110"
              [class.text-white]="!isWishlisted(wp.id.toString())"
              [class.text-[#600b0b]]="isWishlisted(wp.id.toString())">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                [attr.fill]="isWishlisted(wp.id.toString()) ? 'currentColor' : 'none'" stroke="currentColor"
                stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
                </path>
              </svg>
            </button>
            <!-- View Similar -->
            <button (click)="navigateToSimilar(wp, $event)"
              class="w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all text-white hover:scale-110"
              title="View Similar">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
              </svg>
            </button>
          </div>

          <!-- Bottom strip: [name|price] default; on hover name slides up, wallpaper_id slides in from below -->
          <div
            class="absolute bottom-0 left-0 right-0 px-2.5 md:px-3 pt-10 pb-1 md:pb-1.5 bg-gradient-to-t from-black/70 via-black/40 to-transparent"
            style="text-shadow: 0 1px 3px rgba(0,0,0,0.6);">
            <div class="flex items-center justify-between gap-2">
              <!-- Name / Wallpaper_id swap slot -->
              <div class="relative flex-1 min-w-0">
                <h3
                  class="font-bold text-white text-[12px] md:text-[14px] truncate leading-tight transition-transform duration-300 ease-out group-hover:-translate-y-[130%]"
                  style="font-family: 'Roboto', sans-serif;">{{ wp.name }}</h3>
                <p
                  class="absolute inset-0 text-white/85 text-[10px] md:text-[11px] font-normal tracking-wide truncate translate-y-full opacity-0 transition-all duration-300 ease-out group-hover:translate-y-0 group-hover:opacity-100">
                  {{ wp.wallpaper_id }}</p>
              </div>
              <!-- Price (always at bottom-right) — actual rate, no flat discount -->
              <div class="flex items-center gap-1 shrink-0">
                <!-- Hidden, not zeroed, when no surface can be priced: "₹0.00/sq.ft"
                     advertises a free wall. The figure is the live "from" rate —
                     the service overrides Solr's indexed one. -->
                <span *ngIf="wp.price" class="font-bold text-white text-[10px] md:text-[12px]">₹{{ wp.price | number:'1.2-2'
                  }}<span class="font-normal text-white/80 text-[9px] md:text-[10px]">/sq.ft</span></span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && totalPages > 1" class="flex items-center justify-center gap-1.5 md:gap-2 mt-8 md:mt-10">

      <button (click)="goToPage(currentPage - 1)"
        class="flex items-center gap-0.5 text-gray-500 hover:text-[#600b0b] transition-colors shrink-0">
       
        <span class="text-[10px] md:text-xs font-bold uppercase tracking-wider">Back</span>
      </button>
      <!-- <button
        (click)="goToPage(currentPage - 1)"
        [disabled]="currentPage === 1"
        class="w-8 h-8 md:w-9 md:h-9 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#600b0b] hover:text-[#600b0b] transition-all disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </button> -->
      <ng-container *ngFor="let p of pageNumbers">
        <span *ngIf="p === -1" class="text-gray-400 text-xs md:text-sm px-0.5 md:px-1">…</span>
        <button *ngIf="p !== -1" (click)="goToPage(p)"
          [class]="'w-8 h-8 md:w-9 md:h-9 rounded-full border flex items-center justify-center text-[10px] md:text-xs font-bold transition-all ' + (p === currentPage ? 'bg-[#600b0b] text-white border-[#600b0b]' : 'border-gray-200 hover:border-[#600b0b] hover:text-[#600b0b]')">{{
          p }}</button>
      </ng-container>
      <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
        class="w-8 h-8 md:w-9 md:h-9 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#600b0b] hover:text-[#600b0b] transition-all disabled:opacity-30 disabled:cursor-not-allowed">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>

    <!-- Page info -->
    <p *ngIf="!isLoading && totalRecords > 0"
      class="text-center text-[10px] md:text-[11px] text-gray-400 mt-3 md:mt-4 font-serif">
      Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ currentPage * pageSize > totalRecords ? totalRecords :
      currentPage * pageSize }} of {{ totalRecords }} wallpapers
    </p>
  </div>

</div>

<!-- ═══════════════ FILTER DRAWER ═══════════════ -->
<div *ngIf="showFiltersMobile" class="fixed inset-0 z-50 flex">
  <div class="absolute inset-0 bg-black/50" (click)="showFiltersMobile = false"></div>
  <div class="relative w-[300px] md:w-[320px] bg-white h-full overflow-hidden shadow-2xl flex flex-col mr-auto">

    <!-- Drawer header -->
    <div class="flex items-center justify-between px-6 py-5 border-b border-gray-100">
      <h3 class="text-sm font-bold uppercase tracking-[0.2em] text-gray-800">Filters</h3>
      <button (click)="showFiltersMobile = false" class="text-gray-400 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Scrollable filter content -->
    <div class="flex-1 overflow-y-auto">

      <!-- Category -->
      <div class="border-b border-gray-100">
        <button (click)="toggleSection('m-category')"
          class="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50">
          <span class="text-[15px] font-semibold text-black">Category</span>
          <svg *ngIf="isSectionExpanded('m-category')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
          <svg *ngIf="!isSectionExpanded('m-category')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div *ngIf="isSectionExpanded('m-category')" class="pb-3 max-h-52 overflow-y-auto">
          <!-- All categories option -->
          <div (click)="onCategoryAllToggle()"
            [class]="'flex items-center justify-between px-6 py-2 cursor-pointer hover:bg-gray-50 ' + (isCategoryAllSelected ? 'bg-[#f9f0f0]' : '')">
            <div class="flex items-center gap-3">
              <input type="checkbox" [checked]="isCategoryAllSelected" (click)="$event.stopPropagation()"
                (change)="onCategoryAllToggle()"
                class="w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#600b0b]" />
              <span
                [class]="'text-xs font-semibold uppercase tracking-wide ' + (isCategoryAllSelected ? 'text-[#600b0b]' : 'text-gray-700')">All</span>
            </div>
          </div>
          <label *ngFor="let item of masterCategories; trackBy: trackById"
            [class]="'flex items-center justify-between px-6 py-2 cursor-pointer hover:bg-gray-50 ' + ((isCategoryAllSelected || selectedCategoryIds.has(item.id)) ? 'bg-[#f9f0f0]' : '')">
            <div class="flex items-center gap-3">
              <input type="checkbox" [checked]="isCategoryAllSelected || selectedCategoryIds.has(item.id)"
                (change)="onCategoryToggle(item.id)"
                class="w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#600b0b]" />
              <span class="text-xs font-semibold uppercase tracking-wide text-gray-700">{{ item.display_name ||
                item.name }}</span>
            </div>
            <span *ngIf="item.count" class="text-xs text-gray-400">({{ item.count }})</span>
          </label>
        </div>
      </div>

      <!-- Space -->
      <div class="border-b border-gray-100">
        <button (click)="toggleSection('m-space')"
          class="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50">
          <span class="text-[15px] font-semibold text-black">Space</span>
          <svg *ngIf="isSectionExpanded('m-space')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
          <svg *ngIf="!isSectionExpanded('m-space')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div *ngIf="isSectionExpanded('m-space')" class="pb-3 max-h-52 overflow-y-auto">
          <!-- All spaces option -->
          <div (click)="onSpaceAllToggle()"
            [class]="'flex items-center justify-between px-6 py-2 cursor-pointer hover:bg-gray-50 ' + (isSpaceAllSelected ? 'bg-[#f9f0f0]' : '')">
            <div class="flex items-center gap-3">
              <input type="checkbox" [checked]="isSpaceAllSelected" (click)="$event.stopPropagation()"
                (change)="onSpaceAllToggle()" class="w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#600b0b]" />
              <span
                [class]="'text-xs font-semibold uppercase tracking-wide ' + (isSpaceAllSelected ? 'text-[#600b0b]' : 'text-gray-700')">All</span>
            </div>
          </div>
          <label *ngFor="let item of masterSpaces; trackBy: trackById"
            [class]="'flex items-center justify-between px-6 py-2 cursor-pointer hover:bg-gray-50 ' + ((isSpaceAllSelected || selectedSpaceIds.has(item.id)) ? 'bg-[#f9f0f0]' : '')">
            <div class="flex items-center gap-3">
              <input type="checkbox" [checked]="isSpaceAllSelected || selectedSpaceIds.has(item.id)"
                (change)="onSpaceToggle(item.id)"
                class="w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#600b0b]" />
              <span class="text-xs font-semibold uppercase tracking-wide text-gray-700">{{ item.display_name ||
                item.name }}</span>
            </div>
            <span *ngIf="item.count" class="text-xs text-gray-400">({{ item.count }})</span>
          </label>
        </div>
      </div>

      <!-- Wallpaper Type -->
      <div class="border-b border-gray-100">
        <button (click)="toggleSection('m-type')"
          class="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50">
          <span class="text-[15px] font-semibold text-black">Wallpaper Type</span>
          <svg *ngIf="isSectionExpanded('m-type')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
          <svg *ngIf="!isSectionExpanded('m-type')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div *ngIf="isSectionExpanded('m-type')" class="pb-3">
          <label *ngFor="let t of ['concept', 'pattern']"
            [class]="'flex items-center gap-3 px-6 py-2 cursor-pointer hover:bg-gray-50 ' + (selectedTypes.has(t) ? 'bg-[#f9f0f0]' : '')">
            <input type="checkbox" [checked]="selectedTypes.has(t)" (change)="onTypeToggle(t)"
              class="w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#600b0b]" />
            <span class="text-xs font-semibold uppercase tracking-wide text-gray-700">{{ t }}</span>
          </label>
        </div>
      </div>

      <!-- Collection Type -->
      <div class="border-b border-gray-100">
        <button (click)="toggleSection('m-quality')"
          class="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50">
          <span class="text-[15px] font-semibold text-black">Collection Type</span>
          <svg *ngIf="isSectionExpanded('m-quality')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
          <svg *ngIf="!isSectionExpanded('m-quality')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div *ngIf="isSectionExpanded('m-quality')" class="pb-3">
          <label *ngFor="let q of ['premium', 'exclusive']"
            [class]="'flex items-center gap-3 px-6 py-2 cursor-pointer hover:bg-gray-50 ' + (selectedQualities.has(q) ? 'bg-[#f9f0f0]' : '')">
            <input type="checkbox" [checked]="selectedQualities.has(q)" (change)="onQualityToggle(q)"
              class="w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#600b0b]" />
            <span class="text-xs font-semibold uppercase tracking-wide text-gray-700">{{ q }}</span>
          </label>
        </div>
      </div>

      <!-- Color -->
      <div class="border-b border-gray-100">
        <button (click)="toggleSection('m-color')"
          class="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50">
          <span class="text-[15px] font-semibold text-black">Color</span>
          <svg *ngIf="isSectionExpanded('m-color')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
          <svg *ngIf="!isSectionExpanded('m-color')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div *ngIf="isSectionExpanded('m-color')" class="px-6 pb-4">
          <div class="flex flex-wrap gap-2 mt-1">
            <button *ngFor="let item of masterColors" (click)="onColorToggle(item.id)"
              [title]="item.display_name || item.name"
              [class]="'w-8 h-8 rounded-full border-2 transition-all ' + (selectedColorIds.has(item.id) ? 'border-[#600b0b] scale-110 shadow-md' : 'border-transparent hover:border-gray-400')"
              [style.background]="item.hex || '#ccc'"></button>
          </div>
          <p *ngIf="selectedColorIds.size > 0"
            class="text-[10px] text-[#600b0b] mt-2 font-bold uppercase tracking-wider">
            {{ selectedColorIds.size }} color{{ selectedColorIds.size > 1 ? 's' : '' }} selected
          </p>
        </div>
      </div>

      <!-- Vastu -->
      <div class="border-b border-gray-100">
        <button (click)="toggleSection('m-vastu')"
          class="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50">
          <span class="text-[15px] font-semibold text-black">Vastu</span>
          <svg *ngIf="isSectionExpanded('m-vastu')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
          <svg *ngIf="!isSectionExpanded('m-vastu')" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-gray-500">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div *ngIf="isSectionExpanded('m-vastu')" class="px-6 pb-4">
          <label class="flex items-center gap-3 cursor-pointer group">
            <input type="checkbox" [checked]="vastu" (change)="onVastuToggle()"
              class="w-4 h-4 rounded border-gray-300 cursor-pointer accent-[#600b0b]" />
            <span class="text-sm text-gray-600 group-hover:text-gray-900 transition-colors">Vastu Friendly Only</span>
          </label>
        </div>
      </div>

      <!-- Clear All / Apply buttons -->
      <div class="px-6 py-5 flex gap-3">
        <button (click)="clearAllFilters(); showFiltersMobile = false" [disabled]="!hasActiveFilters"
          class="flex-1 border border-gray-300 text-gray-700 py-2.5 rounded-lg font-bold uppercase tracking-wider text-xs hover:border-[#600b0b] hover:text-[#600b0b] transition-colors disabled:opacity-40 disabled:cursor-not-allowed">Clear
          All</button>
        <button (click)="showFiltersMobile = false"
          class="flex-1 bg-[#600b0b] text-white py-2.5 rounded-lg font-bold uppercase tracking-wider text-xs hover:bg-[#8c1c1c] transition-colors">Apply</button>
      </div>

    </div>
  </div>
</div>